export const priorityTypes = {
  SHIT_PRIORITY_ANY: 'any',
  SHIT_PRIORITY_MIT: 'today',
  SHIT_PRIORITY_BIGROCK: 'this week'
}
